module.exports = __webpack_public_path__ + "img/k3.dea86713.jpg";